module.exports = __webpack_public_path__ + "banner.png?49273cb7558ba3b5f627f9dd0803700a";